import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { InstacartAccountQueryInput } from '@/models/instacartAccount';

type DownloadInstacartAccountsInput = Omit<InstacartAccountQueryInput, 'pagination'>;

export const downloadInstacartAccounts = async ({
  email,
  country,
  isClosed,
  orderBy,
  sortType,
}: DownloadInstacartAccountsInput): Promise<string> => {
  const response = await queryExecute({
    query: graphql(`
      query DownloadInstacartAccounts($email: String, $country: InstacartCountry, $isClosed: Boolean, $orderBy: String, $sortType: String) {
        downloadInstacartAccounts(email: $email, country: $country, isClosed: $isClosed, orderBy: $orderBy, sortType: $sortType)
      }
    `),
    variables: {
      email,
      country,
      isClosed,
      orderBy,
      sortType,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data?.downloadInstacartAccounts ?? '';
};
